import { useTranslation } from "react-i18next"

import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useGeneralSettings } from "@/hooks/use-module-settings"

export function ShouldStreamCheckbox() {
  const { t } = useTranslation()

  const { settings, updateSettings } = useGeneralSettings()
  const shouldStream = settings?.shouldStream ?? true

  function handleCheckedChange(checked: boolean) {
    // Optimistic update to database
    void updateSettings({ shouldStream: checked })
  }

  return (
    <section className="flex items-center gap-2">
      <Checkbox checked={shouldStream} id="should-stream" onCheckedChange={handleCheckedChange} />
      <Tooltip>
        <TooltipTrigger>
          <Label htmlFor="should-stream">{t("pages.common.stream_answers")}</Label>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="top">
          <p>{t("settingsmenu.stream_answers")}</p>
        </TooltipContent>
      </Tooltip>
    </section>
  )
}
